import EditIcon from "@mui/icons-material/Edit"
import EditOffIcon from "@mui/icons-material/EditOff"
import { Box, IconButton, Tooltip } from "@mui/material"
import { extraColors } from "../../utils/theme"

interface EditModeToggleProps {
  isEditing: boolean
  onToggle: () => void
  drawerOpen: boolean
  drawerWidth: number
}

export const EditModeToggle = ({
  isEditing,
  onToggle,
  drawerOpen,
  drawerWidth,
}: EditModeToggleProps) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 12,
        right: drawerOpen ? drawerWidth + 12 : 12,
        zIndex: 1,
        transition: theme =>
          theme.transitions.create("right", {
            duration: theme.transitions.duration.enteringScreen,
          }),
      }}
    >
      <Tooltip
        title={isEditing ? "Exit edit mode" : "Enter edit mode"}
        placement="left"
        disableInteractive
      >
        <IconButton
          onClick={onToggle}
          aria-label={isEditing ? "Exit edit mode" : "Enter edit mode"}
          sx={{
            bgcolor: isEditing
              ? extraColors.status.navyLight
              : extraColors.dark5,
            color: isEditing ? extraColors.dark : extraColors.white,
            "&:hover": {
              bgcolor: isEditing
                ? extraColors.status.navyLight
                : extraColors.dark10,
            },
            boxShadow: 2,
          }}
        >
          {isEditing ? <EditOffIcon /> : <EditIcon />}
        </IconButton>
      </Tooltip>
    </Box>
  )
}
